import React from 'react';
import { CHECKOUT_URL } from '../data/coachSystem';
import { PRODUCT_EVENT_PARAMS, trackMetaEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  /** 'scroll' jumps to the final offer section, 'checkout' opens the checkout. */
  action?: 'scroll' | 'checkout';
  variant?: 'orange' | 'outline';
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  action = 'scroll',
  variant = 'orange',
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const palette = variant === 'outline' ? 'border border-ivory/25 bg-transparent text-ivory hover:border-orange hover:text-orange focus-visible:outline-orange' : 'bg-orange text-ink hover:bg-orange-deep hover:text-ivory focus-visible:outline-orange';
  const sizing = size === 'lg' ? 'px-7 py-4 text-[0.95rem]' : 'px-6 py-3.5 text-[0.85rem]';
  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    /* Land on the offer block itself so the checkout button is always in
       view, not just the top of the section. */
    const target = document.getElementById('pricing') ?? document.getElementById('offer');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  const handleCheckout = () => {
    trackMetaEvent('InitiateCheckout', PRODUCT_EVENT_PARAMS);
  };
  const shared = `inline-flex w-full items-center justify-center gap-2 rounded-full font-display font-semibold uppercase tracking-[0.08em] shadow-card transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${sizing} ${className}`;
  if (action === 'checkout') {
    return <a href={CHECKOUT_URL} onClick={handleCheckout} className={shared} data-id="element-30" data-mp="bi6oxjsa1hkm">
        {label} <span aria-hidden="true" data-id="element-31" data-mp="gff9ts4t7zpk">→</span>
      </a>;
  }
  return <a href="#pricing" onClick={handleScroll} className={shared} data-id="element-32" data-mp="3mxgt489scfa8">
      {label} <span aria-hidden="true" data-id="element-33" data-mp="3mxqko0ahaui1">→</span>
    </a>;
}